import { LogType } from './const';
import { ILog, ILogger } from './ilogger';

const init = () => {};

const log: ILog = (t, msg, area) => {
  const data = Array.isArray(msg) ? msg : [msg];
  const date = new Date().toLocaleTimeString();
  const content = [date, area + '::', ...data];
  switch (t) {
    case LogType.Info:
      console.log(content);
      break;
    case LogType.Warn:
      console.warn(content);
      break;
    case LogType.Error:
      console.error(content);
      break;
    default:
      break;
  }
};

const ConsoleLogger: ILogger = { init, log };

export default ConsoleLogger;
